import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router'
import { Button } from 'antd'
import { ErrorToast, SuccessToast } from 'components/ui/toast/toastsTemplates'
import lmsProfilesCreate from 'api/lms-profiles/Create'
import { LmsProfileTypes } from 'enum/lms-profile-types.enum'
import { useTranslationRankmi } from 'helpers/translations.helper'
import { ProfileRoutes } from 'enum/routes'
import { useCreateProfile } from '../../context'
import { Wrapper } from './styled'

export const Buttons = () => {
  const { t } = useTranslation()
  const tRelative = useTranslationRankmi({
    prefix: 'configuration.lmsProfiles.create',
  })

  const history = useHistory()

  const { formState, getValues } = useCreateProfile()

  const goToMain = () => {
    history.push(ProfileRoutes.MAIN)
  }

  const onSave = async () => {
    if (!formState.isValid) return

    const { name, color, profileType, users, segments } = getValues()

    try {
      const lmsProfile = await lmsProfilesCreate({
        name,
        color,
        profileType,
        userIds:
          profileType === LmsProfileTypes.participants
            ? users.map((user) => user.userId)
            : undefined,
        segmentIds:
          profileType === LmsProfileTypes.segments
            ? segments.map((segment) => segment.segmentId)
            : undefined,
      })
      SuccessToast(t('administration.toastMessages.profileCreateSuccess'))
      history.push(ProfileRoutes.MAIN)
    } catch (e) {
      ErrorToast(t('administration.toastMessages.createError'))
    }
  }

  return (
    <Wrapper>
      <Button onClick={goToMain}>{tRelative('buttons.cancel')}</Button>
      <Button onClick={onSave} disabled={!formState.isValid}>
        {tRelative('buttons.saveV2')}
      </Button>
    </Wrapper>
  )
}
